// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Version/Version.css
// module id = 85
// module chunks = 0